var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdlib(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_246_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.666 55.5076C110 53.2797 113.501 51.3475 117.128 49.723C127.417 45.1151 132.562 42.8112 139.406 47.2453C146.25 51.6793 146.25 58.9528 146.25 73.4998V84.7498C146.25 98.8919 146.25 105.963 150.643 110.356C155.037 114.75 162.108 114.75 176.25 114.75H187.5C202.047 114.75 209.32 114.75 213.755 121.594C218.189 128.438 215.885 133.583 211.277 143.872C209.652 147.499 207.72 151 205.492 154.334C197.663 166.051 186.535 175.183 173.516 180.576C160.497 185.969 146.171 187.38 132.35 184.631C118.529 181.882 105.833 175.096 95.8687 165.131C85.9042 155.167 79.1183 142.471 76.3691 128.65C73.6199 114.829 75.0309 100.503 80.4236 87.4836C85.8164 74.4644 94.9486 63.3366 106.666 55.5076Z",
    fill: "url(#paint0_linear_246_1444)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.845 74.0176C214.757 58.5624 202.438 46.2434 186.983 40.1549C175.421 35.6002 165 46.0737 165 58.5001V88.5001C165 92.6423 168.358 96.0001 172.5 96.0001H202.5C214.926 96.0001 225.4 85.5791 220.845 74.0176Z",
    fill: "#777777",
    fillOpacity: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_246_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1104 122.005C33.3333 120.52 35.6672 119.232 38.0855 118.149C44.9449 115.077 48.3746 113.541 52.9373 116.497C57.5 119.453 57.5 124.302 57.5 134V141.5C57.5 150.928 57.5 155.642 60.429 158.571C63.3579 161.5 68.0719 161.5 77.5 161.5H85C94.698 161.5 99.547 161.5 102.503 166.063C105.459 170.625 103.923 174.055 100.851 180.915C99.7682 183.333 98.4801 185.667 96.9948 187.89C91.7755 195.701 84.357 201.789 75.6775 205.384C66.998 208.979 57.4473 209.92 48.2332 208.087C39.0191 206.255 30.5554 201.731 23.9125 195.088C17.2695 188.445 12.7455 179.981 10.9127 170.767C9.07992 161.553 10.0206 152.002 13.6157 143.323C17.2109 134.643 23.2991 127.225 31.1104 122.005Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.23 134.345C103.171 124.042 94.9585 115.829 84.655 111.77C76.9473 108.733 70 115.716 70 124V144C70 146.762 72.2386 149 75 149H95C103.284 149 110.267 142.053 107.23 134.345Z",
    fill: "#777777"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_246_1444",
    x: 52,
    y: 13,
    width: 196,
    height: 196,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_246_1444"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_246_1444",
    x: 0,
    y: 99,
    width: 122.353,
    height: 122.353,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.35294,
    dy: 2.35294
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.35294
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_246_1444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_246_1444",
    x1: 164.855,
    y1: 90.9695,
    x2: 86.2907,
    y2: 163.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdlib);
export default __webpack_public_path__ + "static/media/ADLIB.46b69ed62f04edae47594e5173f7eea8.svg";
export { ForwardRef as ReactComponent };